import { useState, createContext, useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import FirstStepA from "./FirstStepA";
import FirstStepB from "./FirstStepB";
import { Axios } from "./Axios";
import ThirdStep from "./ThirdStep";
import CheckMailPage from "./check-email-page";
import { ReactComponent as Loader } from "./images/loader.svg";
import { useTranslation } from "react-i18next";
import validate from "./commponents/validator";
import axios from "axios";

export const FormContext = createContext({});

export interface Values {
  project_name: string;
  category: string;
  email: string;
  phone: string;
  agreement: boolean;
  language: string;
  country: string;
  url: string;
  acquired_by?: string;
  first_name?: string;
  last_name?: string;
  on_behalf?: string;
}

function AppForm() {
  const [values, setValues] = useState<Values>({
    project_name: "",
    category: "",
    email: "",
    phone: "",
    agreement: false,
    language: localStorage.getItem("lang") || "en",
    country: "sk",
    url: "",
    acquired_by: "",
    first_name: "",
    last_name: "",
    on_behalf: "",
  });
  const [errors, setErrors] = useState<any>({
    project_name: "",
    category: "",
    email: "",
    phone: "",
    agreement: "",
    language: "",
    country: "",
    url: "",
    other: "",
  });
  const [searchParmas, setSearchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("lang")) {
      fetch("https://ipapi.co/json/")
        .then((res) => res.json())
        .then((response) => {
          setValues({
            ...values,
            country: response.country_code.toLowerCase(),
          });
          console.log(response);

          setValues({
            ...values,
            language: response.country_code.toLowerCase(),
          });

          localStorage.setItem("lang", response.country_code.toLowerCase());
          localStorage.setItem(
            "i18nextLng",
            response.country_code.toLowerCase()
          );
          window.location.reload();
        })
        .catch((data: any) => {
          console.error("Request failed:", data);
          setValues({ ...values, country: "sk", language: "en" });
        });
    }
  }, []);
  const handleChange = (event: any) => {
    setErrors({
      ...errors,
      other: "",
      [event.target.name]: "",
    });
    if (location.pathname !== second_step) {
      setErrors(validate(values, t));
    }
    if (
      location.pathname === first_stepB ||
      location.pathname === first_stepA
    ) {
      setErrors(validate({ [event.target.name]: event.target.value }, t));
    }
    if (event.target.name !== "phone" && event.target.name !== "country") {
      event.persist();
    }
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
    if (event.target.name === "agreement") {
      setValues({
        ...values,
        agreement: !values.agreement,
      });
      if (values.agreement === true) {
        setErrors({ ...errors, agreement: false });
      }
    }
  };
  useEffect(() => {
    setValues({
      ...values,
      language: localStorage.getItem("i18nextLng") || "en",
      country: localStorage.getItem("i18nextLng") || "sk",
      on_behalf:
        new URLSearchParams(window.location.search).get("on_behalf") || "",
    });
  }, []);

  const location = useLocation();

  const navigate = useNavigate();
  const first_stepA = "/";
  const first_stepB = "/2";
  const second_step = "/3";
  const third_step = "/4";
  const finish = "/finish";
  const pathName = location.pathname;

  const handleNavigate = async (e: any) => {
    setErrors(validate(values, t));
    if (pathName === "/") {
      if (validate(values, t).project_name === "") {
        navigate(first_stepB);
      } else {
        setErrors({ project_name: validate(values, t).project_name });
      }
    }
    if (location.pathname === first_stepB) {
      if (validate(values, t).category === "") {
        navigate(second_step);
      }
    }
    if (location.pathname === second_step) {
      if (
        validate(values, t).email === "" &&
        validate(values, t).phone === "" &&
        values.agreement === true
      ) {
        handleSubmit(e);
      }
    }
  };
  const handleSubmit = (event: any) => {
    if (event) event.preventDefault();
    setErrors(validate(values, t));
    setIsSubmitting(true);
    SignUp(values);
  };
  console.log(values);

  const SignUp = async ({
    project_name,
    email,
    phone,
    category,
    country,
    language,
    url,
    acquired_by,
    first_name,
    last_name,
    on_behalf,
  }: Values) => {
    if (url) {
      if (url.startsWith("http://")) {
        url = url;
      } else if (url.startsWith("https://")) {
        url = url;
      } else if (!url.startsWith("https://")) {
        url = "https://" + url;
      } else if (!url.startsWith("http://")) {
        url = "https://" + url;
      }
    }

    try {
      const { data } = await Axios.post(
        "/companies",
        {
          name: project_name,
          email,
          phone,
          language: language ? language : localStorage.getItem("lang") || "en",
          category,
          country: country ? country : "sk",
          url,
          acquired_by,
          first_name,
          last_name,
          on_behalf,
        },
        {
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );
      handleHubspotForm();
      setErrors({ ...errors, other: "" });
      navigate(third_step);
    } catch (e: any) {
      setErrors({ ...errors, other: e.response.data.errors });
    }
    setIsSubmitting(false);
  };

  const portalId = "26891853";
  let formGuid = "2e0edb53-7746-4b3e-a881-923b3dfcda7e";
  if (localStorage.getItem("i18nextLng") === "cs") {
    formGuid = "ff6e4ffe-280c-48e9-9dc3-e8b81a2274ed";
  } else if (localStorage.getItem("i18nextLng") === "sk") {
    formGuid = "3c73754c-a1d4-4e3a-aaed-585576a68def";
  } else if (localStorage.getItem("i18nextLng") === "en") {
    formGuid = "2e0edb53-7746-4b3e-a881-923b3dfcda7e";
  } else if (localStorage.getItem("i18nextLng") === "de") {
    formGuid = "44098778-11ee-40c1-af1d-2eb8e6cb304a";
  }

  const handleHubspotForm = async () => {
    await axios.post(
      `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
      {
        portalId,
        formGuid,
        fields: [
          {
            name: "company",
            value: values.project_name,
          },
          {
            name: "email",
            value: values.email,
          },
          {
            name: "mobilephone",
            value: values.phone,
          },
          {
            name: "0-2/comu_sa_venuje_",
            value: values.category,
          },
          {
            name: "0-2/domain",
            value: values.url,
          },
          {
            name: "on_behalf",
            value: values.on_behalf,
          },
          {
            name: "acquired_by",
            value: values.acquired_by,
          },
          {
            name: "firstname",
            value: values.first_name,
          },
          {
            name: "lastname",
            value: values.last_name,
          },

          {
            name: "language",
            value: values.language,
          },
          {
            name: "country",
            value: values.country,
          },
        ],
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const { t } = useTranslation();
  useEffect(() => {
    setValues({
      ...values,
      language: localStorage.getItem("i18nextLng") || "en",
    });
  }, [localStorage.getItem("lang")]);

  return (
    <>
      <FormContext.Provider
        value={{
          values,
          errors,
          handleChange,
          setErrors,
          setValues,
        }}
      >
        <div className="appForm">
          <div className="form">
            <div className="form-start">
              <h3 style={{ padding: 5 }}>
                {t("signup__heading")
                  .split("\n")
                  .map((item) => item + " \n")}
              </h3>
              <div className="progressBar">
                <div
                  className={
                    pathName === first_stepA
                      ? "progressBarStep"
                      : "progressBarBulletCheck"
                  }
                  style={
                    pathName === first_stepA ||
                    pathName === first_stepB ||
                    pathName === second_step ||
                    pathName === finish ||
                    pathName === third_step
                      ? { color: "#f26431", border: "solid #f26431" }
                      : {}
                  }
                >
                  <div
                    className={
                      pathName === second_step
                        ? "icon-checklist:before"
                        : "progressBarBullet"
                    }
                  >
                    {pathName === first_stepA ? "1" : ""}
                  </div>
                </div>
                <div
                  className="progressBarPath"
                  style={
                    pathName === first_stepB ||
                    pathName === third_step ||
                    pathName === finish ||
                    pathName === second_step
                      ? { backgroundColor: "#f26431" }
                      : {}
                  }
                ></div>
                <div
                  className={
                    pathName === third_step ||
                    pathName === finish ||
                    pathName === second_step
                      ? "progressBarBulletCheck"
                      : "progressBarStep"
                  }
                  style={
                    pathName === first_stepB ||
                    pathName === third_step ||
                    pathName === finish ||
                    pathName === second_step
                      ? { color: "#f26431", border: "solid #f26431" }
                      : {}
                  }
                >
                  <div
                    className={
                      pathName === finish || pathName === third_step
                        ? "icon-checklist:before"
                        : "progressBarBullet"
                    }
                  >
                    {pathName === third_step ||
                    pathName === finish ||
                    pathName === second_step
                      ? ""
                      : "2"}
                  </div>
                </div>
                <div
                  className="progressBarPath"
                  style={
                    pathName === third_step ||
                    pathName === finish ||
                    pathName === second_step
                      ? { backgroundColor: "#f26431" }
                      : {}
                  }
                ></div>
                <div
                  className={
                    pathName === finish || pathName === third_step
                      ? "progressBarBulletCheck"
                      : "progressBarStep"
                  }
                  style={
                    pathName === third_step || pathName === second_step
                      ? { color: "#f26431", border: "solid #f26431" }
                      : {}
                  }
                >
                  <div
                    className={
                      pathName === finish || pathName === third_step
                        ? "icon-checklist:before"
                        : "progressBarBullet"
                    }
                  >
                    {pathName === finish || pathName === third_step ? "" : "3"}
                  </div>
                </div>
              </div>

              <div className="horizontalLine"></div>
            </div>

            <form onSubmit={handleSubmit}>
              <Routes>
                <Route path="/" element={<FirstStepA />} />
                <Route path="/2" element={<FirstStepB />} />
                <Route path="/3" element={<ThirdStep />} />
                <Route path="/4" element={<CheckMailPage />} />
              </Routes>
            </form>

            <div className="form-end">
              {location.pathname !== "/third_step" && (
                <button
                  className="buttonNextStep"
                  type="submit"
                  onClick={handleNavigate}
                >
                  {!isSubmitting ? (
                    t("signup__nextButton")
                  ) : (
                    <Loader className="spinner" />
                  )}
                </button>
              )}

              {location.pathname !== "/" &&
                location.pathname !== "/third_step" && (
                  <button
                    onClick={() => navigate(-1)}
                    className="buttonBackStep"
                  >
                    {t("signup__backButton")}
                  </button>
                )}
            </div>
          </div>
          <div className="formLogin">
            <a href="https://app.zooza.sk/#/login">
              {t("signup__loginButton")}
            </a>
          </div>
        </div>
      </FormContext.Provider>
    </>
  );
}
export default AppForm;
